import React from 'react';

import { bookingsStrings } from '@data/bookings';
import { moneyStrings } from '@data/money';
import { payeeStrings, paymentSlipStrings } from '@data/paymentSlip';
import { preAlertStrings } from '@data/preAlert';
import Checkbox from '@material-ui/core/Checkbox';
import { PaymentSlip, PaymentSlipHelper } from '@models/next/PaymentSlip';
import { makeMuiStyles } from '@styles/index';
import { formatDate } from '@utils/types';
import { Checklist } from '@utils/useChecklist';

const useStyles = makeMuiStyles((theme, common) => ({
  paymentSlipListTable: {
    width: '100%',
    borderSpacing: 0,
    '& th': {
      ...common.fontWeight500,
      ...common.whitespacePre,
      padding: '0 10px',
      lineHeight: '50px',
      textAlign: 'left',
      position: 'sticky',
      top: 0,
      backgroundColor: theme.palette.base[200],
      zIndex: 10,
    },
    '& td': {
      ...common.textGray700,
      padding: '0 10px',
      lineHeight: '40px',
      maxWidth: 150,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  checkboxRoot: {
    margin: -5,
  },
}));

interface PaymentSlipSimpleListProps {
  items: PaymentSlip[];
  checklist?: Checklist<number>;
}

export const PaymentSlipSimpleList: React.FC<PaymentSlipSimpleListProps> = (props) => {
  const { items, checklist } = props;
  const classes = useStyles();

  return (
    <table className={classes.paymentSlipListTable}>
      <thead>
        <tr>
          {checklist && <th></th>}
          <th>{paymentSlipStrings.no}</th>
          <th>{bookingsStrings.consignee}</th>
          <th>{paymentSlipStrings.payment_slip_no}</th>
          <th>{paymentSlipStrings.fc_payment_slip_no}</th>
          <th>{preAlertStrings.job_code}</th>
          <th>{payeeStrings.payee}</th>
          <th>{paymentSlipStrings.payment_type}</th>
          <th>{paymentSlipStrings.payment_date_shimebarai}</th>
          <th>{paymentSlipStrings.deadline_shimebarai}</th>
          <th>{paymentSlipStrings.total_amount}</th>
        </tr>
      </thead>

      <tbody>
        {items.map((item, index) => (
          <tr key={item.id}>
            {checklist && (
              <td>
                <Checkbox
                  classes={{
                    root: classes.checkboxRoot,
                  }}
                  color="primary"
                  checked={checklist.checked(item.id)}
                  onClick={() => checklist.toggle(item.id)}
                />
              </td>
            )}
            <td>{index + 1}</td>
            <td>{item.booking_inquiry.consignee?.company_name || '-'}</td>
            <td>{item.payment_slip_no || '-'}</td>
            <td>{item.fc_payment_slip_no || '-'}</td>
            <td>{item.pre_alert.job_code || '-'}</td>
            <td>{item.payee.name_en || '-'}</td>
            <td>{item.payment_type || '-'}</td>
            <td>{formatDate(item.payment_date) || '-'}</td>
            <td>{formatDate(item.cutoff_date) || '-'}</td>
            <td>{moneyStrings.formatYenFront(new PaymentSlipHelper(item).getTotalAmount())}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
